<template>
  <div class="addNewClass">
    <div class="shade">
      <div class="hintCont" draggable="true">
        <div class="title">
          <span>添加参数</span>
          <img src="@/assets/images/close.png" alt @click="closePage" />
        </div>
        <el-row :gutter="20">
          <el-col :span="6">
            <div class="grid-content bg-purple lft">
              <span>参数名称</span>
            </div>
          </el-col>
          <el-col :span="15">
            <div class="grid-content bg-purple-light">
              <el-input
                v-model="name"
                placeholder="请输入内容"
                size="small"
              ></el-input>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6">
            <div class="grid-content bg-purple lft">
              <span>参数类型</span>
            </div>
          </el-col>
          <el-col :span="15">
            <div class="grid-content bg-purple-light">
              <template>
                <el-select v-model="type" placeholder="请选择" size="small">
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </template>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6">
            <div class="grid-content bg-purple lft">
              <span>参数选项</span>
            </div>
          </el-col>
          <el-col :span="15">
            <div class="grid-content bg-purple-light">
              <el-input
                v-model="value"
                placeholder="多个用空格隔开，文本框类型可不填"
                size="small"
              ></el-input>
            </div>
          </el-col>
        </el-row>
        <div class="Operation">
          <el-button
            type="primary"
            size="small"
            style="width:100%"
            @click="upPara"
            >确认</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { addPara } from "../../api/mall.js";
export default {
  computed: {
    ...mapGetters(["token", "merch_id", "app_id"])
  },
  data() {
    return {
      type: "text",
      name: "",
      value: "",
      options: [
        {
          value: "text",
          label: "文本框"
        },
        {
          value: "radio",
          label: "单选框"
        },
        {
          value: "checkbox",
          label: "多选框"
        }
      ]
    };
  },
  methods: {
    closePage() {
      this.$emit("close", false);
    },
    upPara() {
      if (this.name == "") {
        this.$message({
          message: "请输入参数名",
          type: "warning"
        });
      } else {
        this.updata();
      }
    },
    updata() {
      console.log(this.value);
      let data = {
        token: this.token,
        app_id: this.app_id,
        value: this.value,
        name: this.name,
        type: this.type,
        merch_id: this.merch_id
      };
      addPara(data).then(res => {
        console.log(res);
        this.$message({
          message: res.msg,
          type: "success"
        });
        this.name = "";
        this.value = "";
        this.$emit("close", false);
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.addNewClass {
  height: 100%;
  position: absolute;
  z-index: 2;
  .shade {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.3);
    .hintCont {
      position: absolute;
      top: 18%;
      width: 500px;
      left: 50%;
      margin-left: -250px;
      background: #fff;
      min-height: 410px;
      .title {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        padding: 10px 20px;
        margin-bottom: 20px;
      }
      .el-row {
        margin-bottom: 20px;
      }
      .grid-content {
        min-height: 36px;
        line-height: 36px;
        .img {
          width: 80px;
          height: 80px;
          margin-top: 15px;
          background: #409eff;
          img {
            width: 100%;
          }
        }
        .el-select {
          width: 100%;
        }
      }
      .lft {
        text-align: right;
      }
      .Operation {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        min-height: 36px;
        margin: 30px 0 0 0;
        padding: 0 20px;
      }
    }
  }
}
</style>
